import React from 'react';

const QUERY = '(max-width: 639.98px)';

export function useIsMaxSm(): boolean {
	const [matches, setMatches] = React.useState(() =>
		typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false,
	);

	React.useEffect(() => {
		const mq = window.matchMedia(QUERY);
		const onChange = () => setMatches(mq.matches);
		onChange();
		mq.addEventListener('change', onChange);
		return () => mq.removeEventListener('change', onChange);
	}, []);

	return matches;
}
